<template>
  <div class="Notice">
    <!-- <navigator :title="serviceMsg.serviceName" :routePath='"/"'></navigator>

    <Tabbar @changeActive='changeActive' :serviceId="serviceMsg.serviceId" :outActive='active'></Tabbar> -->
    <div class="onehome">
      <van-icon @click='back' class="return" color="#fff" name="arrow-left" />
      <h3 class="title">附近</h3>
      <div class="imgbox">
        <van-icon name="chat-o" size='.6rem' color='#fff' @click='toModule("/personal/News")' />
        <van-icon name="scan" style="margin-left:6px" color="#fff" size='.6rem' @click='toScan' />
      </div>
    </div>
    <router-view></router-view>
    
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      active: 0,
      serviceMsg: {},
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    };
  },
  methods: {
    changeActive(index) {
      this.active = index;
      if (index === 4) {
        this.$router.push({path: '/humanResource/jobList', query:this.$route.query});
      } else if (index === 5) {
        this.$router.push({path: '/humanResource/serviceList', query:this.$route.query});
      } else {
        this.$router.push({path: '/humanResource/eduList', query:this.$route.query});
      }
    },
    back(){
        this.$router.go(-1);//返回上一层
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {

        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },
  },
  components: {Tabbar},
  created() {
    this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 5;
    });
    const path = this.$route.path.split('/')[2];
    if (path === 'jobList') {
      this.active = 4;
    } else if (path === 'serviceList') {
      this.active = 5;
    } else if (path === 'eduList') {
      this.active = 6;
    }
  },
  computed: {
    ...mapGetters(['parkServiceList','token']),
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.Notice{
  background: rgb(245, 245, 245);
}
.onehome{
  background: #205eff;
  width: 100%;
  height: 1.2rem;
  display: flex;
  justify-content:space-between;
  align-items: center;
  .return{
    padding-left: .18rem;
  }
  .title{
    text-align: center;
    color: #fff;
    padding-left: .88rem;
  }
  .imgbox{
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: .18rem;
  }
}
.van-tabbar{
  position: relative;
  height: 2.986667rem;
  padding: .533333rem .533333rem 0 .533333rem;
  box-sizing: border-box;
  .van-tabbar-item{
    .van-tabbar-item__icon .icon_wrap{
      width: 1.333333rem;
      height: 1.333333rem;
      border-radius: 50%;
      border: .026667rem solid rgb(241, 241, 241);
      text-align: center;
      line-height: 1.333333rem;
      .iconfont{
        font-size: .72rems;
        color: $color-main;
      }
    }
    .van-tabbar-item__text .text_wrap{
      text-align: center;
      .text{
        line-height: .88rem;
        font-size: .32rem;
        color: rgb(51, 51, 51);
        font-weight: 600;
      }
      .active_icon{
        display: inline-block;
        border-bottom: .266667rem solid rgb(245, 245, 245);
        border-left: .266667rem solid transparent;
        border-right: .266667rem solid transparent;
      }
      .hidden_icon{
        display: inline-block;
        height: .266667rem;
      }
    }
  }
}
.van-hairline--top-bottom::after {
    border-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/humanResource/HumanResource.vue